export default "__VITE_ASSET__DxUZosfV__"